import { Input } from "antd";
import Typography from "./Typography";
import { COLORS } from "../constants/Colors";
import React from "react";

const MyInput = (props) => {
  const {
    isRequired,
    label = "",
    errorMsg,
    isError,
    className,
    isPassword,
    description,
    isBold,
    ...rest
  } = props;

  return (
    <div className={className}>
      {label !== "" && (
        <div className="d-flex align-items-center pb-2">
          <Typography isBold={isBold} size="14px" color={COLORS.Purple}>
            {label}
          </Typography>
          {isRequired && (
            <Typography
              isBold
              size="14px"
              color={COLORS.Error}
              className="pl-2"
            >
              *
            </Typography>
          )}
          {description && (
            <Typography size="12px" color="#909AAF" className="pl-2">
              {description}
            </Typography>
          )}
        </div>
      )}
      {isPassword ? (
        <Input.Password className="w-100" {...rest} />
      ) : (
        <Input className="w-100" {...rest} />
      )}
      {isError && (
        <div className="pt-1 pl-1">
          <Typography color={COLORS.Error} size="13px">
            {errorMsg}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default MyInput;
